"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const novoColorPalette_1 = __importDefault(require("./novoColorPalette"));
const spacing_1 = __importDefault(require("./tokens/spacing"));
const typographySet_1 = require("./tokens/typographySet");
const novoDark = {
    // Tokens
    // Primary action colour
    // Primary buttons
    action01: novoColorPalette_1.default.blue06,
    // Secondary action color
    // Secondary buttons
    action02: novoColorPalette_1.default.gray09,
    // Destructive button background
    // Text
    // Icon
    // Border
    action03: novoColorPalette_1.default.red06,
    // Selected elements
    // Active elements
    action04: novoColorPalette_1.default.blue06,
    // Links
    action05: novoColorPalette_1.default.blue07,
    // Link on high contrast backgrounds
    action06: novoColorPalette_1.default.blue05,
    // Primary text
    // Body copy
    // Headers
    // Labels
    // Secondary buttons
    textColor01: novoColorPalette_1.default.white,
    // Secondary text
    // Placeholder text
    // Helper text
    textColor02: novoColorPalette_1.default.gray08,
    // Text on interactive colours
    // Reverse text colour
    // Reverse icon colour
    textColor04: novoColorPalette_1.default.gray02,
    // Data table row text
    textColor05: novoColorPalette_1.default.gray08,
    // Button Primary, Destructive
    textColor06: novoColorPalette_1.default.white,
    // Text on yellow alert background
    textColor07: novoColorPalette_1.default.gray02,
    // Error text
    // Error icons
    error01: novoColorPalette_1.default.red07,
    // Success button
    // Success icons
    success01: novoColorPalette_1.default.green04,
    // Warning icons
    // Notification counter primary
    warning01: novoColorPalette_1.default.yellow05,
    // Impartial
    info01: novoColorPalette_1.default.gray05,
    // Subtle border
    // Progress indicator background
    ui01: novoColorPalette_1.default.gray05,
    // Secondary background
    // Border
    ui02: novoColorPalette_1.default.gray03,
    // Off states
    ui03: novoColorPalette_1.default.gray06,
    // Emphasis form elements
    // Tab border hover
    // Shadows
    ui04: novoColorPalette_1.default.white,
    // Default input fields
    // Zebra highlighting in tables
    ui05: novoColorPalette_1.default.purple02,
    // Page background
    // Dialpad background
    // Overflow menu background
    // Modal background
    // Calendar container
    ui06: novoColorPalette_1.default.purple01,
    // High contrast background
    // Tooltip background
    ui07: novoColorPalette_1.default.gray10,
    // Subtle border on high contrast background
    ui08: novoColorPalette_1.default.gray09,
    // Highlight tag
    ui09: novoColorPalette_1.default.blue09,
    // Offline presence background
    // Tooltip background
    ui10: novoColorPalette_1.default.gray05,
    ui11: novoColorPalette_1.default.coolgray01,
    ui12: novoColorPalette_1.default.coolgray02,
    ui13: novoColorPalette_1.default.blue03,
    ui14: novoColorPalette_1.default.green03,
    // Overlay background
    overlay01: `${novoColorPalette_1.default.gray02}BF`,
    // Dialog shadows
    shadow01: novoColorPalette_1.default.gray01,
    // Primary icons
    icon01: novoColorPalette_1.default.white,
    // Icons on interactive colors
    icon02: novoColorPalette_1.default.white,
    // Disabled icons on backgrounds
    icon03: novoColorPalette_1.default.gray05,
    // Coachmark icon
    icon04: novoColorPalette_1.default.blue05,
    // Icons on secondary buttons
    icon05: novoColorPalette_1.default.gray02,
    // Disabled icons
    icon06: novoColorPalette_1.default.gray05,
    // Disabled icons on high contrast backgrounds
    icon07: novoColorPalette_1.default.gray06,
    // Icons on yellow alert background
    icon08: novoColorPalette_1.default.gray02,
    // Interactive tokens
    // Focus
    focus01: novoColorPalette_1.default.blue06,
    // Disabled backgrounds
    disabled01: novoColorPalette_1.default.gray08,
    // Disabled text
    disabled02: novoColorPalette_1.default.gray05,
    // Disabled on high contrast background
    disabled03: novoColorPalette_1.default.gray08,
    // Disabled text on buttons
    disabled04: novoColorPalette_1.default.gray06,
    // Primary button hover
    hover01: novoColorPalette_1.default.blue07,
    // Primary button active
    active01: novoColorPalette_1.default.blue05,
    // Secondary button hover
    hover02: novoColorPalette_1.default.gray10,
    // Secondary button active
    active02: novoColorPalette_1.default.gray08,
    // Destructive button hover
    hover03: novoColorPalette_1.default.red07,
    // Destructive button active
    active03: novoColorPalette_1.default.red05,
    // Success button hover
    hover04: novoColorPalette_1.default.green06,
    // Success button active
    active04: novoColorPalette_1.default.green04,
    // Icon Background hover
    hover05: novoColorPalette_1.default.gray03,
    // Icon Background active
    active05: novoColorPalette_1.default.gray05,
    // Date picker number hover
    hover06: novoColorPalette_1.default.gray05,
    // Links hover
    hover07: novoColorPalette_1.default.blue08,
    // Links active
    active07: novoColorPalette_1.default.blue05,
    // Dropdown hover
    // Overflow menu hover
    // Dialpad number hover
    hover08: novoColorPalette_1.default.purple02,
    // Dialpad number active
    // Table row selected
    active08: novoColorPalette_1.default.gray04,
    // Tertiary button reverse
    hover09: novoColorPalette_1.default.gray05,
    // Tertiary button reverse background
    active09: novoColorPalette_1.default.gray03,
    // Data visualisation
    data01: novoColorPalette_1.default.magenta07,
    data02: novoColorPalette_1.default.midnight06,
    data03: novoColorPalette_1.default.violet07,
    data04: novoColorPalette_1.default.teal07,
    data05: novoColorPalette_1.default.pink07,
    data06: novoColorPalette_1.default.midnight08,
    data07: novoColorPalette_1.default.magenta06,
    data08: novoColorPalette_1.default.orange07,
    data09: novoColorPalette_1.default.violet06,
    data10: novoColorPalette_1.default.teal06,
    dataText01: novoColorPalette_1.default.gray02,
    dataText02: novoColorPalette_1.default.gray02,
    dataText03: novoColorPalette_1.default.gray02,
    dataText04: novoColorPalette_1.default.gray02,
    dataText05: novoColorPalette_1.default.gray02,
    dataText06: novoColorPalette_1.default.gray02,
    dataText07: novoColorPalette_1.default.white,
    dataText08: novoColorPalette_1.default.gray02,
    dataText09: novoColorPalette_1.default.white,
    dataText10: novoColorPalette_1.default.white,
    // Typography
    label01: typographySet_1.label01,
    labelBold01: typographySet_1.labelBold01,
    body01: typographySet_1.body01,
    bodyBold01: typographySet_1.bodyBold01,
    body02: typographySet_1.body02,
    bodyBold02: typographySet_1.bodyBold02,
    bulletList01: typographySet_1.bulletList01,
    heading01: typographySet_1.heading01,
    heading02: typographySet_1.heading02,
    // Spacing
    spacing01: spacing_1.default.spacing01,
    spacing02: spacing_1.default.spacing02,
    spacing03: spacing_1.default.spacing03,
    spacing04: spacing_1.default.spacing04,
    spacing05: spacing_1.default.spacing05,
    spacing06: spacing_1.default.spacing06,
    spacing07: spacing_1.default.spacing07,
    spacing08: spacing_1.default.spacing08,
    spacing09: spacing_1.default.spacing09,
    // Box Shadows
    shadowLow: `0px 1px 2px 1px ${novoColorPalette_1.default.gray01}`,
    shadowMedium: `0px 2px 8px 2px ${novoColorPalette_1.default.gray01}`,
    shadowHigh: `0px 2px 20px 9px ${novoColorPalette_1.default.gray01}`,
};
exports.default = novoDark;
